import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"

// components
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {PH_IMAGE} from "../../../components/i18n/placeHolders"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {
    FL_ATTRIBS,
    FL_CATEGORY,
    FL_IMAGE,
    FL_ORDER,
    FL_STATUS,
    FL_SUB_CATEGORY,
} from "../../../components/i18n/formLabels";
import {
    INTERNATIONAL,
    REQUIRED
} from "../../../components/i18n/i18n"

// services

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {dishDrinkService} from "../../../jwt/_services/ayb/dishDrinkService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import {DishDrinkLangs} from "./_langs";
import SelectMultipleGeneric from "../../../components/select/selectMultipleGeneric";
import {aybAttributeProvider} from "../../../providers/aybAttributeProvider";
import {paramSettingsProvider} from "../../../providers/paramSettingsProvider";
import {aybCategoryProvider} from "../../../providers/aybCategoryProvider";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";


const DishDrinkForm = props => {
    const path = props?.path ;

    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { app, udn, category, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []
    const [status, setStatus] = useState(domainObject?.status || true);
    const [categoryId, setCategoryId] = useState(domainObject?.category?.id || null);
    const [subCategoryId, setSubCategoryId] = useState(domainObject?.subCategory?.id  || null);
    const [selectedAttribs, setSelectedAttribs] = useState(domainObject?.attributes || []);
    const [durationOptions, setDurationOptions ] = useState( domainObject?.durationOptions || [] );
    const [aybMenuId, setAybMenuId] = useState( domainObject?.aybMenu?.id || null);


    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `item_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            image: domainObject?.image,
            showOrder: domainObject?.showOrder,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  fbDataBase,
            item: {
                ...data,
                aybMenu : { id : aybMenuId },
                langs : langs,
                attributes : selectedAttribs,
                durationOptions : mergeOptions(durationOptions)
            }
        }

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if (categoryId !== undefined && categoryId !== null )
            dataRequest.item.category = { id : categoryId };
        else
            dataRequest.item.category = null

        if (subCategoryId !== undefined && subCategoryId !== null )
            dataRequest.item.subCategory = { id : subCategoryId };
        else
            dataRequest.item.subCategory = null


        if (!editMode)
            genericIndexedActions.save(path, dishDrinkService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, dishDrinkService, id, dataRequest)
        }

        closeForm()
    };

    const mergeOptions = (_durationOptions) => {
        let durationOptionsString = ''

        _durationOptions.map((option) => {
            if (durationOptionsString === '')
                durationOptionsString += option.id;
            else
                durationOptionsString += (',' + option.id);

        });

        return durationOptionsString
    }

    const closeForm = () => {
        reset();
        props.toggle()
    }


    return <>
        <Card className={'card-big-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                </>
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={handleSubmit(onSubmit)}
                    />
                    {
                        editMode && <>
                            <GenericButton
                                style={'table'}
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_IMAGE}</Label>
                                <Input
                                    type="text"
                                    name="image"
                                    placeholder={PH_IMAGE}
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_ORDER}</Label>
                                <Input
                                    type="number"
                                    name="showOrder"
                                    min="0"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        {
                            (category === 'REST' || category === 'HCDP_CUISINE;HCDP_BAR;HCDP_INSIDE_HOUSE') ?
                                <Col md="6">
                                    <FormGroup>
                                        <SelectMultipleGeneric
                                            title={FL_ATTRIBS}
                                            initialValues={selectedAttribs}
                                            setExternalValue={setSelectedAttribs}
                                            provider={aybAttributeProvider}
                                            maxSelection={3}
                                        />
                                    </FormGroup>
                                </Col> :
                                (category === 'XPA' || category === 'HCDP_SPA') ?
                                    <Col md="3">
                                        <FormGroup>
                                            <SelectMultipleGeneric
                                                title={'Opciones de duración'}
                                                initialValues={durationOptions}
                                                setExternalValue={setDurationOptions}
                                                provider={paramSettingsProvider}
                                                customFilter={{item: {ps_key: 'xkynet_config_xpa_duration_times'}}}
                                            />
                                        </FormGroup>
                                    </Col> : null

                        }
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_CATEGORY}</Label>
                                {
                                    category !== null ?
                                        <SelectGeneric
                                            initialValue={categoryId}
                                            setExternalValue={value => setCategoryId(value)}
                                            provider={aybCategoryProvider}
                                            customFilter={{
                                                category: category,
                                            }}
                                        /> : null
                                }
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_SUB_CATEGORY}</Label>
                                {
                                    category !== null ?
                                        <SelectGeneric
                                            initialValue={subCategoryId}
                                            setExternalValue={value => setSubCategoryId(value)}
                                            provider={aybCategoryProvider}
                                            customFilter={{
                                                category: category,
                                            }}
                                        /> : null
                                }
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className={'form-container'}>
                        <div className={''}>
                            <h2>{INTERNATIONAL}</h2>
                        </div>
                        <div className={''}>
                            <Row>
                                <DishDrinkLangs
                                    langs={langs}
                                    setLangs={setlangs}
                                    translatableLangs={translatableLangs}
                                />
                            </Row>
                        </div>
                    </div>
                </Form>
            </CardBody>
        </Card>
        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>

}
export default DishDrinkForm